import { render, staticRenderFns } from "./CompetitionJoinDialog.vue?vue&type=template&id=1fa46895&scoped=true"
import script from "./CompetitionJoinDialog.vue?vue&type=script&lang=js"
export * from "./CompetitionJoinDialog.vue?vue&type=script&lang=js"
import style0 from "./CompetitionJoinDialog.vue?vue&type=style&index=0&id=1fa46895&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa46895",
  null
  
)

export default component.exports